import { api, apiClient } from './client'
import type {
  AuthSessionResponse,
  LoginRequest,
  MeResponse,
  RegisterRequest,
} from './types'

/**
 * Client auth — Sanctum personal access tokens (API_DOCUMENTATION §5.1–5.4).
 * Paths relative to `VITE_API_BASE_URL` (`/api` → upstream `/client/...`).
 */
export const authApi = {
  register: (body: RegisterRequest) =>
    api.post<AuthSessionResponse>('/client/auth/register', {
      device_name: 'velox-web',
      ...body,
    }),

  login: (body: LoginRequest) =>
    api.post<AuthSessionResponse>('/client/auth/login', {
      device_name: 'velox-web',
      ...body,
    }),

  me: () => api.get<MeResponse>('/client/auth/me'),

  /** 204 No Content — deletes only the current Bearer token. */
  logout: async (): Promise<void> => {
    await apiClient.post('/client/auth/logout')
  },
}
